module.exports = __webpack_public_path__ + "8cd4c5b1a4c9bcb00f16da9adefe5ea8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/quiz-draft.png
// module id = 309
// module chunks = 0